module.exports = __webpack_public_path__ + "img/distribution.3384a9ad.webp";